import { render } from "./CourseContentBrowser.vue?vue&type=template&id=45b508cc&scoped=true"
import script from "./CourseContentBrowser.vue?vue&type=script&lang=js"
export * from "./CourseContentBrowser.vue?vue&type=script&lang=js"

import "./CourseContentBrowser.vue?vue&type=style&index=0&id=45b508cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b508cc"]])

export default __exports__